import { Badge } from '../../ui/badge';
import { formatSlaRemaining } from '../../../data/crmTicketConstants';

const SLA_CLASSES = {
  on_time: 'bg-green-100 text-green-800',
  due_soon: 'bg-amber-100 text-amber-800',
  overdue: 'bg-red-100 text-red-700',
};

export default function CrmTicketSlaBadge({ slaStatus, remainingSeconds, dueDate }) {
  if (!dueDate) return null;
  const label = slaStatus === 'overdue' ? 'Overdue' : slaStatus === 'due_soon' ? 'Due Soon' : 'On Time';
  const detail = formatSlaRemaining(remainingSeconds);

  return (
    <Badge variant="secondary" className={SLA_CLASSES[slaStatus] || SLA_CLASSES.on_time}>
      {label}{detail ? ` · ${detail}` : ''}
    </Badge>
  );
}
